import { render, staticRenderFns } from "./_ChannelStylesForm.vue?vue&type=template&id=227d131e&scoped=true&"
import script from "./_ChannelStylesForm.vue?vue&type=script&lang=ts&"
export * from "./_ChannelStylesForm.vue?vue&type=script&lang=ts&"
import style0 from "./_ChannelStylesForm.vue?vue&type=style&index=0&id=227d131e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227d131e",
  null
  
)

export default component.exports